module.exports = __webpack_public_path__ + "img/status-canceled.03b30a4e.svg";